export const MODAL_TYPE_EMOTIONS_LIST = 'emotions-list';
